import { LitElement, html } from "lit-element";
import "./midi-in";

class MidiContainer extends LitElement {
  static get properties() {
    return {
      availableInputs: { type: Array },
      value: { type: Number },
    };
  }

  constructor() {
    super();

    this.value = 0;

    const createLoop = () => {
      let up = true;
      return () => {
        new Tone.Loop((time) => {
          if (up && this.value < 100) {
            this.value++;
          } else if (up && this.value === 100) {
            up = false;
          } else if (!up && this.value > 1) {
            this.value--;
          } else {
            up = true;
          }
        }, "64n").start(0);
      };
    };

    const loop = createLoop();
    loop();
  }

  render() {
    return html`
      <midi-in
        position="absolute"
        width="100%"
        height="100%"
        backgroundColor="#0B1A13"
      ></midi-in>

      <midi-in
        name="horizontal"
        position="absolute"
        transport
        origin="bottom"
        transportNoteSpeed="16n"
        numNotes="16"
        noteFadeSpeed="1"
        size="1"
        mode="sequential-position"
        width="100%"
        height="100%"
        backgroundColor="transparent"
        startColor="rgb(255, 255, 0)"
        endColor="rgb(200, 200, 0)"
        noteOpacity="1"
      ></midi-in>

      <midi-in
        name="horizontal"
        position="absolute"
        transport
        origin="top"
        transportNoteSpeed="16n"
        numNotes="16"
        noteFadeSpeed="1"
        size="1"
        mode="sequential-position"
        noteWidth="${100 - this.value + 1}"
        width="100%"
        height="100%"
        backgroundColor="transparent"
        startColor="#7A0F22"
        endColor="#09BC8A"
        noteOpacity="1"
      ></midi-in>

      <midi-in
        name="horizontal"
        position="absolute"
        transport
        origin="bottom"
        transportNoteSpeed="16n"
        numNotes="16"
        noteFadeSpeed="1"
        size="1"
        mode="sequential-position"
        noteWidth="${100 - this.value + 1}"
        noteWidthOrigin="right"
        width="100%"
        height="100%"
        backgroundColor="transparent"
        startColor="#7A0F22"
        endColor="#09BC8A"
        noteOpacity="1"
      ></midi-in>
    `;
  }
}

customElements.define("midi-container", MidiContainer);
